"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _lodash = _interopRequireDefault(require("lodash.merge"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var RETRY_LIMIT = 3;

var styles = function styles() {
  return {
    root: {
      margin: 'auto'
    },
    loadingContainer: {
      zIndex: 3,
      height: '100%',
      width: '100%',
      display: 'grid',
      placeContent: 'center'
    },
    loader: {
      color: 'black'
    }
  };
};

var DocumentImage = /*#__PURE__*/function (_Component) {
  _inherits(DocumentImage, _Component);

  function DocumentImage() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DocumentImage);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DocumentImage)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      currentImageUrl: null,
      imageCache: {}
    });

    _defineProperty(_assertThisInitialized(_this), "preloadImageFromUrl", function (url) {
      return new Promise(function (resolve, reject) {
        var img = new Image();
        img.onerror = reject;

        img.onload = function () {
          return resolve(url);
        };

        img.src = url; // Attach image object to component instance to stop it getting garbage collected

        _this["___".concat(url)] = img;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "loadUpstreamImage", function (documentId, page) {
      var retry = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var _this$props = _this.props,
          getDocumentImageUrls = _this$props.getDocumentImageUrls,
          throwFatalError = _this$props.throwFatalError;
      return getDocumentImageUrls({
        documentId: documentId,
        page: page
      }).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 1),
            url = _ref2[0];

        return _this.preloadImageFromUrl(url);
      }).catch(function (err) {
        if (retry > RETRY_LIMIT) {
          throwFatalError('Unable to load Document Images', err);
          return;
        }

        return _this.loadUpstreamImage(documentId, page, retry + 1);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getPageImage", function (page) {
      var docId = _this.props.doc.id;
      var imageCache = _this.state.imageCache; // Get image url from cache if there...

      var docImageCache = imageCache[docId];

      if (docImageCache) {
        var cachedPromiseOfUrl = docImageCache[page];
        if (cachedPromiseOfUrl) return cachedPromiseOfUrl;
      } // ...otherwise load image from upstream


      var promiseOfUrl = _this.loadUpstreamImage(docId, page);

      _this.setState(function (_ref3) {
        var imageCache = _ref3.imageCache;
        var newImageCache = (0, _lodash.default)({}, imageCache, _defineProperty({}, docId, _defineProperty({}, page, promiseOfUrl)));
        return {
          imageCache: newImageCache
        };
      });

      return promiseOfUrl;
    });

    _defineProperty(_assertThisInitialized(_this), "getCurrentImage", function () {
      _this.setState({
        currentImageUrl: null
      });

      var _this$props2 = _this.props,
          doc = _this$props2.doc,
          onLoad = _this$props2.onLoad,
          page = _this$props2.page;
      if (!doc) return;
      return _this.getPageImage(page).then(function (url) {
        return _this.setState({
          currentImageUrl: url
        }, onLoad);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getRestOfDocImages", function () {
      var _this$props3 = _this.props,
          doc = _this$props3.doc,
          page = _this$props3.page;
      var pages = doc.images.filter(function (img) {
        return img.page !== page;
      }).map(function (_ref4) {
        var page = _ref4.page;
        return {
          page: page,
          isRequired: doc.fields.some(function (field) {
            return field.isRequired && field.page === page;
          })
        };
      }); // Fetch pages with required fields before pages without

      var priorityPromises = pages.filter(function (_ref5) {
        var isRequired = _ref5.isRequired;
        return isRequired;
      }).map(function (_ref6) {
        var page = _ref6.page;
        return _this.getPageImage(page);
      });
      Promise.all(priorityPromises).then(function () {
        return pages.filter(function (_ref7) {
          var isRequired = _ref7.isRequired;
          return !isRequired;
        }).forEach(function (_ref8) {
          var page = _ref8.page;
          return _this.getPageImage(page);
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getCurrentDocumentImages", function () {
      return _this.getCurrentImage().then(_this.getRestOfDocImages);
    });

    _defineProperty(_assertThisInitialized(_this), "reloadCurrentDocumentImages", function () {
      var docId = _this.props.doc.id;

      _this.setState(function (_ref9) {
        var imageCache = _ref9.imageCache;
        return {
          imageCache: _objectSpread({}, imageCache, _defineProperty({}, docId, undefined))
        };
      }, _this.getCurrentDocumentImages);
    });

    return _this;
  }

  _createClass(DocumentImage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getCurrentDocumentImages();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _prevProps$doc = prevProps.doc;
      _prevProps$doc = _prevProps$doc === void 0 ? {} : _prevProps$doc;
      var prevDocId = _prevProps$doc.id;
      var _this$props$doc = this.props.doc;
      _this$props$doc = _this$props$doc === void 0 ? {} : _this$props$doc;
      var currDocId = _this$props$doc.id;
      var docHasChanged = currDocId !== prevDocId;

      if (docHasChanged) {
        this.getCurrentDocumentImages();
        return;
      }

      var prevPage = prevProps.page;
      var currPage = this.props.page;
      var pageHasChanged = currPage !== prevPage;
      if (pageHasChanged) this.getCurrentImage();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          classes = _this$props4.classes,
          doc = _this$props4.doc,
          zoom = _this$props4.zoom,
          className = _this$props4.className;
      var currentImageUrl = this.state.currentImageUrl;

      var _ref10 = doc || {},
          height = _ref10.height,
          width = _ref10.width,
          templateName = _ref10.templateName;

      height *= zoom;
      width *= zoom;

      if (!currentImageUrl) {
        return _react.default.createElement("div", {
          className: classes.loadingContainer,
          "data-test-id": "DocumentImage-loading"
        }, _react.default.createElement(_core.CircularProgress, {
          classes: {
            root: classes.loader
          }
        }));
      }

      return _react.default.createElement("div", {
        className: (0, _classnames.default)(classes.root, className),
        style: {
          height: height,
          width: width
        }
      }, _react.default.createElement("img", {
        draggable: false,
        src: currentImageUrl,
        alt: templateName,
        style: {
          height: height,
          width: width
        },
        "data-test-id": "DocumentImage-img",
        onError: this.reloadCurrentDocumentImages
      }));
    }
  }]);

  return DocumentImage;
}(_react.Component);

var _default = (0, _styles.withStyles)(styles)(DocumentImage);

exports.default = _default;